import * as sha256js from 'js-sha256';

export async function sha256(message: string): Promise<string> {
  if (typeof window === 'undefined') {
    // In case the code is running in Node (which you don’t need here)
    throw new Error("Not supported in a Node environment!");
  }

  // 1. Use Web Crypto API if available (browser)
  if (typeof crypto?.subtle !== 'undefined') {
    const data = new TextEncoder().encode(message);
    const buf  = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(buf))
                .map(b => b.toString(16).padStart(2, '0'))
                .join('');
  }

  // 2. Fallback to js-sha256 (for compatibility in case crypto.subtle isn't available)
  return sha256js.sha256(message);  // Use the sha256 function from js-sha256
}

export const baseUrl = "https://land.maidbsk.ip-ddns.com:4443/"
export const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
};